import { FlexBox, Grid } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { formatDate } from 'shared/helpers/formatters'
import { SafetyEvent } from 'shared/models/compliance'
import { midGray, primaryBlack } from 'shared/theme/colors'

export function SafetyEventViolationAccordionDetails({ safetyEvent }: { safetyEvent: SafetyEvent }) {
  return (
    <FlexBox isColumn>
      <Text variant="label2" mb={0.5}>
        {safetyEvent.description ?? safetyEvent.eventDetails}
      </Text>
      <Text variant="label3" mb={3}>
        Violation code {safetyEvent.violationCode}
      </Text>

      <Grid columns="1fr 1fr" gap="8px">
        <FlexBox isColumn gap="8px">
          <Grid columns="120px 120px" gap="8px">
            <Text variant="label3" fontColor={midGray}>
              Violation date
            </Text>
            <Text variant="header4" fontColor={primaryBlack}>
              {formatDate(safetyEvent.eventStart)}
            </Text>
          </Grid>
          <Grid columns="120px 120px" gap="8px">
            <Text variant="label3" fontColor={midGray}>
              Received date
            </Text>
            <Text variant="header4" fontColor={primaryBlack}>
              {formatDate(safetyEvent.eventEnd)}
            </Text>
          </Grid>
          <Grid columns="120px 120px" gap="8px">
            <Text variant="label3" fontColor={midGray}>
              Inspection
            </Text>
            <Text variant="header4" fontColor={primaryBlack}>
              Level {safetyEvent.inspectionLevel}
            </Text>
          </Grid>
        </FlexBox>

        <FlexBox isColumn gap="8px">
          <Grid columns="120px 120px" gap="8px">
            <Text variant="label3" fontColor={midGray}>
              Truck VIN
            </Text>
            <Text variant="header4" fontColor={primaryBlack}>
              {safetyEvent.primaryVin}
            </Text>
          </Grid>
          <Grid columns="120px 120px" gap="8px">
            <Text variant="label3" fontColor={midGray}>
              Trailer VIN
            </Text>
            <Text variant="header4" fontColor={primaryBlack}>
              {safetyEvent.secondaryVin}
            </Text>
          </Grid>
          <Grid columns="120px 120px" gap="8px">
            <Text variant="label3" fontColor={midGray}>
              Reported state
            </Text>
            <Text variant="header4" fontColor={primaryBlack}>
              {safetyEvent.state}
            </Text>
          </Grid>
        </FlexBox>
      </Grid>
    </FlexBox>
  )
}
export function SafetyEventFMCSAAccidentAccordionDetails({ safetyEvent }: { safetyEvent: SafetyEvent }) {
  // TODO: implement this once we figure out the separate details for FMCSA accidents
  return <SafetyEventViolationAccordionDetails safetyEvent={safetyEvent} />
}
export function SafetyEventCTAccidentAccordionDetails({ safetyEvent }: { safetyEvent: SafetyEvent }) {
  // TODO: implement this once we figure out the separate details for CT accidents
  return <SafetyEventViolationAccordionDetails safetyEvent={safetyEvent} />
}
export function SafetyEventOtherAccordionDetails({ safetyEvent }: { safetyEvent: SafetyEvent }) {
  // TODO: implement this once we figure out the separate details for other safety events
  return <SafetyEventViolationAccordionDetails safetyEvent={safetyEvent} />
}
